import { LangCode, languages } from '../../composables/useLocale'

export default (value: LangCode) =>
	languages()
		.map(({ code }) => code)
		.includes(value)
